interface ConfigObject {
    domain              : string
    questsUrl           : string
    pointsUrl           : string
    googleMapsApiKey    : string

    // mapId is a Google Maps concept — it's an identifier you create in the Google Cloud Console that links to a specific
    // map style and configuration. It's required for AdvancedMarkerElement to work (Google enforces this).
    //
    // The value 8e0a97af9386fef is Google's own public demo map ID, documented in their migration guide specifically
    // for testing the Advanced Markers migration. It's not tied to your API key or project — anyone can use it in development.
    //
    // For production you'll need to create your own map ID:
    // 1. Go to Google Cloud Console → Google Maps Platform → Map Management
    // 2. Create a new map ID (select "JavaScript" and enable "Advanced Markers")
    mapId               : string

    center              : {
        "lat": number
        "lng": number
    },

    zoom                : number
}

export default class Config {
    private static _data: ConfigObject;

    static async load() {
        const res = await fetch('config.json', { cache: 'no-cache' })
        const json = await res.json()
        this._data = json as ConfigObject
    }

    static get() {
        return this._data
    }
}